/**
 * @module styled-components
 */

import styled from "styled-components";

/**
 * Standardized button component.
 */
export const Button = styled.button`
  filter: grayscale(${props => (props.disabled ? 1 : 0)});
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  font-size: 11px;
  background-color: ${props => props.theme.button.standard.background};
  width: ${props => props.width || "auto"};
  min-height: ${props => props.minHeight || "2rem"};
  border: 1px solid rgba(0,0,0,.1);

  padding: 0 0.75rem;
  box-shadow: inset 0 0 0 10em
        transparent, 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 280ms ease
  border-radius: 4px;
  &:active,
  &:focus {
    outline: 0 !important;
  }
  &:active {
    box-shadow: inset 0 0 0 10em
        ${props =>
          props.theme.button.clickOverlay}, 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  }
  &:hover {
    box-shadow: inset 0 0 0 10em
        ${props => props.theme.button.hoverOverlay},
      0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
      0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  }
  & > svg {
    margin-right: ${props => (props.iconOnly ? 0 : "0.25rem")};
  }
`;

export const OutlinedButton = styled(Button)`
  background-color: transparent;
  border: 1px solid ${props => props.theme.button.outlined.border};
  box-shadow: none;
  &:active {
    box-shadow: inset 0 0 0 10em ${props => props.theme.button.clickOverlay} !important;
  }
  &:hover {
    box-shadow: inset 0 0 0 10em ${props => props.theme.button.hoverOverlay};
  }
`;

export const TextButton = styled(OutlinedButton)`
  border: 0;

  &:active {
    background-color: ${props => props.theme.button.clickOverlay};
  }
  &:hover {
    background-color: ${props => props.theme.button.hoverOverlay};
  }
`;

export const IconButton = styled.button`
  color: ${props => props.theme.button.icon.color};
  cursor: pointer;
  transition: box-shadow 280ms ease;
  padding: 0.15rem;
  border-radius: 4px;

  :hover {
    box-shadow: ${props =>
      props.hoverEffect
        ? `inset 0 0 0 10em ${props.theme.button.hoverOverlay}`
        : "none"};
  }

  :focus {
    outline: 0;
  }
`;

/**
 * Icon for button.
 */
export const ButtonIcon = styled.img`
  height: 1rem;
  margin-right: ${props => (props.iconOnly ? 0 : "0.5rem")};
`;



// WEBPACK FOOTER //
// ./app/styled-components/Button.js